module.exports = __webpack_public_path__ + "img/Hamburger_Icon_Hover.31240276.svg";